/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-confusing-arrow */
import React, {
  useEffect,
  useState,
  Suspense,
  lazy,
} from 'react';
import { PageParams } from 'constants/interfaces/GlobalInterfaces';
import { useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import SecondaryHeading from 'modules/Common/Components/SecondaryHeading';
import ViewSwitcherComponent from 'modules/Common/Components/ViewSwitcherComponent';
import ToggleFilterButtonGlobal from 'modules/Common/Components/ToggleFilterButtonGlobal';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { message } from 'antd';
import {
  maxTablet, maxWidth, midMobile, retina,
} from 'constants/utilsStyles';
import SkeletonCustom from 'modules/Common/Skeleton/SkeletonCustom';
import ConfirmDialog from 'modules/Common/Components/ConfirmDialog';
import { getFromQueryString, getQueryEmailId } from 'modules/EmailBrowser/utils';
import { gillRoyMoveDown } from 'modules/Content/DragnDrop/actions';
import { TAB_AUDIENCE } from 'constants/paths';
import { addGillRoyIconWhenAudienceSelected, removeGillRoyIconWhenAudienceSelected, getQueryListId } from 'utils';

import { IGetGlobalContactsParams, ISortConfig, ISortOrder } from '../interfaces2';
// import ContactCardSkeleton from 'modules/Common/Skeleton/ContactCardSkeleton';
import ContactsTileTable from '../Components/TableForTileView/ContactsTileTable';
import {
  loadGlobalContactsAction,
  resetGlobalContactsAction,
  deleteGlobalContactsAction,
  resetGlobalContactsSearchedAction,
  addToListContactsAction,
  updateCurrentActiveList,
  globalContactsSelectionSetAction,
  globalContactsSelectionResetAction,
  globalContactsAddToListModeAction,
} from '../Actions/globalContanctsActions';
import ContactsGrid from '../Components/GridView/ContactsGrid';
import {
  globalContactsFiltersApplyAction,
  globalContactsResetFilterSearchAction,
  globalContactsResetFiltersAction,
  listContactsFiltersApplyAction,
  listContactsResetFilterSearchAction,
  listContactsResetFiltersAction,
  loadGlobalDesignationsAction,
  loadGlobalOrganizationsAction,
} from '../Actions/contactsFiltersActions';
import { addContactsToExistingListAction, removeSearchTermOnly } from '../Actions/listDetailsActions';
// import { IGetGlobalContactsParams } from '../interfaces2';
import { IContactItem, FooterActionsEnum } from '../interface';
import { refreshLists } from '../Actions/listsActions';
// import { addGillRoyIcon, removeGillRoyIcon } from '../../../utils';
interface WrapperProps {
  addToListMode?: boolean;
  isContactSelected?: string;
}

const ContactsFooterWrapper = lazy(() => import('modules/Audience/Components/Footer/ContactsFooter'));

const Wrapper = styled.div<WrapperProps>`
  &.tableViewContainer {
    margin-bottom: 0px;
  }
  &.tableViewMainContainer {
    .contacts-tile-table-wrapper {
      .aud-Infinite-scroll {
        overflow-y: auto;
        overflow-x: hidden !important;
        .ant-table-wrapper {
          .ant-table {
            .ant-table-container {
              .ant-table-body {
                max-height: ${(props) => props.addToListMode ? 'calc(72vh - 345px) !important' : 'calc(100vh - 345px) !important'};
                @media all and (max-width: ${maxWidth}), ${retina} {
                  max-height: ${(props) => props.addToListMode ? 'calc(75vh - 295px) !important' : 'calc(100vh - 295px) !important'};
                }
              }
            }
          }
        }
      }
    }
  }
  &.shortHeight {
    &:nth-child(2) {
      &:after {
        content: '';
        height: ${(props) => props.isContactSelected ? '63px' : '0px'};
        width: 100%;
        display: block;
        background-color: #f9f8f6;
      }
    }
    .contacts-tile-table-wrapper {
      .aud-Infinite-scroll {
        overflow-y: auto;
        overflow-x: hidden !important;
      }
    }
  }
  margin: 15px 0 20px 0;
  @media all and (max-width: ${maxWidth}), ${retina} {
    margin: 10px 0 10px 0;
  }
  .heading-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-right: 25px;
    min-height: 37px;
    @media all and (max-width: ${maxTablet}) {
      position: relative;
    }
    .heading-filter-div {
      display: flex;
      align-items: center;
      width: calc(100% - 110px);
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: calc(100% - 100px);
      }
      .secondary-heading {
        max-width: 17%;
        margin-bottom: 0px !important;
        @media all and (max-width: ${maxTablet}) {
          max-width: 100%;
        }
      }
      .toggle-filter-btn-global {
        max-width: 70%;
        margin-left: 10px;
        @media all and (max-width: ${maxTablet}) {
          max-width: 100%;
        }
      }
      @media all and (max-width: ${maxTablet}) {
        flex-direction: column;
        align-items: flex-start;
        .toggle-filter-btn-global {
          margin-top: 10px;
          margin-left: 0px;
          .filters-div {
            .drop-down-btn-global-wrapper {
              .right-separator {
                display: none;
              }
              svg {
                margin-left: 2px;
              }
            }
          }
        }
      }
    }
    .view-switch-cmp {
      @media all and (max-width: ${maxTablet}) {
        margin-right: 6px;
        position: absolute;
        top: 0px;
        right: 10px;
      }
    }
  }
  .contacts-row {
    margin: 10px 0;
    &.emptyRowContactsGrid {
      height: calc(100% - 30px);
      .no-data-found {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
  .aud-Infinite-scroll {
    .audience-module-row {
      @media all and ((min-width: ${maxTablet}) and (max-width: ${maxWidth})) , ${retina} {
        margin-left: -12px !important;
      }
    }
  }
  @media all and (max-width: ${midMobile}) {
    .heading-div{
      width: 100%;
      .heading-filter-div {
        width: 100%;
      }
    }
  }
`;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;

type Props = {
  page: string | undefined,
  listView: boolean,
  isDashboard?: boolean,
  isGlobal?: boolean,
  addToListMode?: boolean;
} & PageParams;

const AudienceContacts = (props: Props) => {
  const listId = getQueryListId();
  const history = useHistory();
  const { pathname } = useLocation();
  const {
    page, listView, isDashboard, isGlobal, addToListMode,
  } = props;
  const [selectedContacts, setSelectedContacts] = useState<IContactItem[]>([]);
  const [selectedContactsIds, setSelectedContactsIds] = useState<number[]>([]);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [showFooter, setShowFooter] = useState<boolean>(false);
  const [footerActionType, setFooterActionType] = useState<string>('');
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [holdSelectedIds, setHoldSelectedIds] = useState<number[]>([]);
  const [addingSingleContact, setAddingSingleContact] = useState<boolean>(false);

  const globalContactsLoading = useSelector((state: RootState) => state.globalContacts.loading);
  const globalContacts = useSelector((state: RootState) => state.globalContacts.contacts);
  const globalTotalContacts = useSelector((state: RootState) => state.globalContacts.totalContacts);
  const globalContactsSearchTerm = useSelector((state: RootState) => state.globalContacts.searchTerm);
  const globalSearchedContacts = useSelector((state: RootState) => state.globalContacts.searchedContacts);
  const globalSearchedContactsLoading = useSelector((state: RootState) => state.globalContacts.searchLoading);
  const globalSearchedTotalContacts = useSelector((state: RootState) => state.globalContacts.totalSearchedContacts);
  const globalContactUpdateSuccess = useSelector((state: RootState) => state.globalContacts.updateContacts.success);
  const activeList = useSelector((state: RootState) => state.globalContacts.currentActiveList);
  const globalAddToListMode = useSelector((state: RootState) => state.globalContacts.addToListGlobalMode);
  const globalContactsNotInListCount = useSelector((state: RootState) => state.globalContacts.totalContactsNotInList);
  const globalSearchedContactsNotInList = useSelector((state: RootState) => state.globalContacts.totalSearchedContactsNotInList);
  const newContactAdded = useSelector((state: RootState) => state.globalContacts.newContactAdded);

  const globalFiltersOrganizations = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters.organization);
  const globalFiltersDesignations = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters.designation);
  const globalFiltersPersonality = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters.personalityType);
  const globalFilterStatus = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters.status);

  const {
    searchTerm: listDetailsSearchTerm,
    listName,
    totalSearchedContacts,
  } = useSelector((state: RootState) => state.audienceListDetailsReducerV2);
  const {
    designation: globalDesignationSelected,
    organization: globalOrganizationSelected,
    personalityType: globalPersonalitySelected,
    status: globalStatusSelected,
  } = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.selectedFilters);
  const isListSelected = useSelector((state: RootState) => state.audienceListsReducerV2.isListSelected);

  const [firstRenderDone, setFirstRenderDone] = React.useState(false);
  const [isSearch, setIsSearch] = React.useState(false);
  const [localSearchTerm, setLocalSearchTerm] = React.useState('');

  // console.log(addToListMode);
  // console.log(listId);

  const filtersApplied = globalFiltersOrganizations.length > 0
    || globalFiltersDesignations.length > 0
    || globalFiltersPersonality.length > 0
    || globalFilterStatus.length > 0;

  const clearSelection = () => {
    setSelectedContacts([]);
    setSelectedContactsIds([]);
    setHoldSelectedIds([]);
    setSelectAll(false);
    setShowFooter(false);
  };

  const SORT_ORDER_DEFAULT = {
    name: null,
    company: null,
    personality: null,
    status: null,
    engagement: null,
  };

  // State for updating sorting order of table columns
  const [sortOrder, setSortOrder] = useState<ISortOrder>(SORT_ORDER_DEFAULT);

  const [sortConfig, setSortConfig] = useState<ISortConfig>({
    // or any initial sorting direction
    sortBy: '',
    // or 'company', 'personality', 'status', 'engagement', etc.
    sortType: '',
  });

  // Updating next sorting order for table header
  function getNextSortingOrder(currentOrder: string | null) {
    if (currentOrder === null) return 'ascend';
    if (currentOrder === 'ascend') return 'descend';
    return null;
  }

  // Updating state of sorting order for updating sort icon on table header
  const updateSortingOrders = (property: keyof ISortOrder) => {
    setSortOrder((prevSortOrder) => ({
      ...SORT_ORDER_DEFAULT,
      [property]: getNextSortingOrder(prevSortOrder[property]),
    }));
  };

  //  Update the sort type (ascending or descending) and sort by(name,company)
  const updateSortingConfig = (sortContactBy: string, sortContactType: string) => {
    setSortConfig((prevConfig) => ({
      ...prevConfig,
      sortBy: sortContactBy,
      sortType: sortContactType,
    }));
  };

  const getParams = (reset?: boolean, useSearchTerm?: string) => {
    const limit = 30;
    // using offset according to the search result or normal result
    const contactsLength = isSearch ? globalSearchedContacts.length : globalContacts.length;
    const offset = contactsLength > 0 && !reset ? contactsLength : 0;
    const { sortBy, sortType } = sortConfig;
    const searchByName = (addToListMode && !globalAddToListMode) ? listDetailsSearchTerm : useSearchTerm || (isSearch ? globalContactsSearchTerm : '');
    const filterByOrganization = isGlobal ? globalFiltersOrganizations : [];
    const filterByDesignation = isGlobal ? globalFiltersDesignations : [];
    const filterByPersonalityType = isGlobal ? globalFiltersPersonality : [];
    const filterByStatus = isGlobal ? globalFilterStatus : [];
    const emailId = isGlobal ? getQueryEmailId() : '';
    const uuid = isGlobal ? getFromQueryString('uuid') : '';

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
      limit,
      offset,
      search_by_name: searchByName,
      sort_by: sortBy,
      sort_type: sortType,
      filter_by_organization: filterByOrganization,
      filter_by_designation: filterByDesignation,
      filter_by_personality_type: filterByPersonalityType,
      filter_by_status: filterByStatus,
      ...(emailId && { email_id: emailId }),
      ...(uuid && { uuid }),
      ...(listId && { list_id: listId }),
    };
  };

  const getDeleteParams = () => {
    const excludedContactIds = selectAll ? selectedContactsIds : [];

    return {
      contactIds: excludedContactIds.length > 0 ? [] : selectedContactsIds,
      deleteAll: selectAll,
      excludedContactIds,
      searchTerm: globalContactsSearchTerm,
      selectedOrganization: globalFiltersOrganizations,
      selectedDesignation: globalFiltersDesignations,
      selectedPersonalityType: globalFiltersPersonality,
      selectedStatus: globalFilterStatus,
      ...(listId && { listId }),
    };
  };

  const handleActiveList = (hardReset?: boolean) => {
    if (hardReset) {
      updateCurrentActiveList('');
      globalContactsSelectionResetAction();
      return;
    }

    if (selectedContactsIds.length > 0 || selectAll) {
      updateCurrentActiveList('global_list');
    } else if (activeList !== 'list') {
      // if currentActive list is global and user change search, it shouldn't reset the currentActive to default.
      // Only reset if current list is "global" and search changes.
      updateCurrentActiveList('');
    }
  };

  const handleResetSelectedContacts = () => {
    setShowFooter(false);
    setSelectedContacts([]);
    setSelectedContactsIds([]);
    setSelectAll(false);
  };

  const handleSelectAll = (flag: boolean) => {
    if (!flag && selectAll) {
      handleResetSelectedContacts();
    } else {
      setSelectAll(flag);
      setSelectedContacts([]);
      setSelectedContactsIds([]);
      setShowFooter(true);
      gillRoyMoveDown();
    }
  };

  const handleSelectContacts = (contact: IContactItem, type?: string) => {
    if (selectedContactsIds.includes(contact.contactId)) {
      const contacts = [...selectedContacts].filter((item) => item.contactId !== contact.contactId).map((item) => item);
      const contactIds = [...selectedContactsIds].filter((item) => item !== contact.contactId).map((item) => item);
      if (contactIds.length > 0) {
        setShowFooter(true);
        gillRoyMoveDown();
      } else if (contactIds.length === 0 && !selectAll) {
        setShowFooter(false);
      }
      setSelectedContacts(contacts);
      setSelectedContactsIds(contactIds);

      if (!selectAll) {
        setHoldSelectedIds(contactIds);
      }
      // setSelectAll(false);
    } else {
      setSelectedContacts((prevContacts) => ([contact, ...prevContacts]));
      setSelectedContactsIds((prevContactIds) => ([contact.contactId, ...prevContactIds]));

      if (selectAll) {
        const removeFromSelectedIds = holdSelectedIds.filter((id) => contact.contactId !== id);
        setHoldSelectedIds(removeFromSelectedIds);
      } else {
        setHoldSelectedIds((prevIds) => ([contact.contactId, ...prevIds]));
      }

      if (!showFooter) {
        if (type !== FooterActionsEnum.ADD_TO_LIST) setShowFooter(true);
      }
    }
  };

  const addContactsToList = () => {
    const excludedContactIds = selectAll ? selectedContactsIds : [];
    if (selectAll && excludedContactIds.length > 0) {
      const contactsToAdd = globalSearchedContacts
        .filter((contact: IContactItem) => !excludedContactIds.includes(contact.contactId))
        .map((filteredContact) => ({ ...filteredContact, isListContact: true }));
      const updatedCount = globalSearchedTotalContacts - excludedContactIds.length;
      addContactsToExistingListAction(contactsToAdd, updatedCount);
    } else if (selectAll) {
      const contactsToAdd = globalSearchedContacts.map((contact) => ({ ...contact, isListContact: true }));
      addContactsToExistingListAction(contactsToAdd, globalSearchedTotalContacts);
    } else {
      const contactsToAdd = selectedContacts.map((contact) => ({ ...contact, isListContact: true }));
      addContactsToExistingListAction(contactsToAdd, (totalSearchedContacts + selectedContactsIds.length));
    }
  };

  const handleConfirmDeleteContact = () => {
    deleteGlobalContactsAction(getDeleteParams())
      .then(() => {
        setFooterActionType('');
        setShowConfirmation(false);
        // Success Toaster
        // eslint-disable-next-line
        message.success({
          content: 'Contact(s) has been deleted successfully.',
        });
      })
      .catch((err) => {
        setFooterActionType('');
        setShowConfirmation(false);
        // Error Toaster
        // eslint-disable-next-line
        message.error({
          content: 'Unable to delete Contact. Please try again later or contact support at support@xiqinc.com.',
        });
        console.log(err);
      });
    clearSelection();
    refreshLists(isSearch, globalContactsSearchTerm);
  };

  const handleAddToListContact = () => {
    addToListContactsAction(getDeleteParams())
      .then(() => {
        addContactsToList();
        setFooterActionType('');
        setShowConfirmation(false);
        clearSelection();
        updateCurrentActiveList('');
        removeSearchTermOnly();
        if (globalAddToListMode) history.push(`/audiences/view/?list_id=${listId}`);
        // Success Toaster
        // eslint-disable-next-line
        message.success({
          content: 'Contact has been added to the list successfully.',
        });
      })
      .catch((err) => {
        setFooterActionType('');
        setShowConfirmation(false);
        clearSelection();
        updateCurrentActiveList('');
        // Error Toaster
        // eslint-disable-next-line
        message.error({
          content: 'Unable to add Contact. Please try again later or contact support at support@xiqinc.com.',
        });
        console.log(err);
      });
  };

  const handleHoldSelectedIds = (ids: number[], removeExcludedIds?: boolean) => {
    console.info(ids);
    if (removeExcludedIds) {
      const contactIds = ids.filter((id) => !selectedContactsIds.includes(id));
      setHoldSelectedIds(contactIds);
    } else {
      setHoldSelectedIds(ids);
    }
  };

  const handleShowConfirmationDialog = (type: string, isSingleContact?: boolean) => {
    setFooterActionType(type);
    setShowConfirmation(true);
    if (isSingleContact) setAddingSingleContact(isSingleContact);
  };

  const handleCloseConfirmationDialog = () => {
    setFooterActionType('');
    setShowConfirmation(false);
    if (addingSingleContact) {
      clearSelection();
      setAddingSingleContact(false);
    }
  };

  const handleGetSelectedIds = () => {
    const excludedContactIds = selectAll ? selectedContactsIds : [];
    if (selectAll && excludedContactIds.length > 0) {
      // const selectedIds = holdSelectedIds.filter((id) => !selectedContactsIds.includes(id));
      return holdSelectedIds;
    }

    if (selectAll) {
      return holdSelectedIds;
    }

    return selectedContactsIds;
  };

  const getFooterCount = () => {
    if (addToListMode && globalAddToListMode && selectAll) {
      return (isSearch ? globalSearchedContactsNotInList : globalContactsNotInListCount) - selectedContactsIds.length;
    }

    if (addToListMode && selectAll) {
      return (isSearch ? globalSearchedTotalContacts : globalTotalContacts) - selectedContactsIds.length - totalSearchedContacts;
    }

    if (selectAll) {
      return (isSearch ? globalSearchedTotalContacts : globalTotalContacts) - selectedContactsIds.length;
    }

    return selectedContactsIds.length;
  };

  useEffect(() => {
    if (globalContactsSearchTerm === '') {
      loadGlobalContactsAction(getParams() as IGetGlobalContactsParams);
    }

    setFirstRenderDone(true);

    if (page === undefined) {
      resetGlobalContactsSearchedAction();
    }

    if (page === 'contacts') {
      // Gets global Organizations and Designations on See All
      loadGlobalOrganizationsAction();
      loadGlobalDesignationsAction();
    }

    // It's a temporary fix pathname === '/audiences/contacts'
    if (pathname === '/audiences/contacts' && listId && !globalAddToListMode) {
      globalContactsAddToListModeAction(true);
    }

    return () => {
      // To set off global add to list mode while leaving the view.
      if (globalAddToListMode) globalContactsAddToListModeAction(false);
    };
  }, []);

  const loadMore = () => {
    if (isSearch ? !globalSearchedContactsLoading : !globalContactsLoading) {
      loadGlobalContactsAction(getParams() as IGetGlobalContactsParams, isSearch);
    }
  };
  const handleApplyFilters = () => {
    if (isGlobal) {
      globalContactsFiltersApplyAction();
    } else {
      listContactsFiltersApplyAction();
    }
  };

  const handleClearFilters = () => {
    clearSelection();
    if (isGlobal) {
      globalContactsResetFiltersAction();
      globalContactsResetFilterSearchAction();
    } else {
      listContactsResetFiltersAction();
      listContactsResetFilterSearchAction();
    }
  };

  const sortGlobalContactsData = () => {
    if (globalContactsSearchTerm === '') {
      resetGlobalContactsAction();
      loadGlobalContactsAction(getParams(true) as IGetGlobalContactsParams, false);
    } else {
      resetGlobalContactsAction();
      resetGlobalContactsSearchedAction();
      loadGlobalContactsAction(getParams(true) as IGetGlobalContactsParams, true);
    }
  };

  useEffect(() => {
    sortGlobalContactsData();
  }, [sortOrder]);

  useEffect(() => {
    if (firstRenderDone) {
      if (isSearch) {
        if (!addToListMode) resetGlobalContactsSearchedAction();
      } else {
        resetGlobalContactsAction();
      }
      loadGlobalContactsAction(getParams(true) as IGetGlobalContactsParams, isSearch);
    }

    // Whenever the filters changes, selection should clear.
    if (selectAll) {
      clearSelection();
    }
  }, [globalFiltersOrganizations, globalFiltersDesignations, globalFiltersPersonality, globalFilterStatus]);

  useEffect(() => {
    if (globalContactsSearchTerm !== '' && globalContactsSearchTerm !== localSearchTerm) {
      if (!isSearch) setIsSearch(true);
      setLocalSearchTerm(globalContactsSearchTerm);
      loadGlobalContactsAction(getParams(true, globalContactsSearchTerm) as IGetGlobalContactsParams, true);
    } else if (globalContactsSearchTerm === '' && isSearch) {
      setLocalSearchTerm('');
      setIsSearch(false);
      loadGlobalContactsAction(getParams(true) as IGetGlobalContactsParams, false);
    }
    // Whenever the search term changes, selection should clear.
    if (selectAll) {
      clearSelection();
    }
  }, [globalContactsSearchTerm]);

  const handleGoBackClick = () => {
    if (filtersApplied) {
      handleClearFilters();
      resetGlobalContactsAction();
      loadGlobalContactsAction(getParams(true) as IGetGlobalContactsParams, isSearch);
    }
  };

  const getConfirmationHandle = () => {
    if (footerActionType === FooterActionsEnum.ADD_TO_LIST) {
      return handleAddToListContact;
    }
    return handleConfirmDeleteContact;
  };

  const getMessageString = () => {
    if (footerActionType === FooterActionsEnum.ADD_TO_LIST) {
      if (selectedContactsIds.length > 1 || selectAll) {
        return `Adding the selected contact(s) will add them into the list (${listName}).`;
      }
      return `Do you want to add ${selectedContacts[0]?.contactName} to the list (${listName}).`;
    }

    return 'Deleting the selected contact(s) will permanently delete them from your Audience. Are you sure you want to proceed?';
  };

  const handleDisableSelectAll = () => {
    if (globalAddToListMode) {
      // Disable selectAll if globalContactsNotInListCount is ZERO.
      return isSearch ? !globalSearchedContactsNotInList : !globalContactsNotInListCount;
    }

    if (addToListMode) {
      return totalSearchedContacts === globalSearchedTotalContacts;
    }

    return false;
  };

  useEffect(() => {
    if (selectAll) {
      removeGillRoyIconWhenAudienceSelected();
      globalContactsSelectionSetAction();
    } else if (selectedContactsIds.length > 0) {
      removeGillRoyIconWhenAudienceSelected();
      globalContactsSelectionSetAction();
    } else {
      addGillRoyIconWhenAudienceSelected();
      globalContactsSelectionResetAction();
    }

    if (addToListMode) handleActiveList();

    return () => handleActiveList(true);
  }, [selectedContactsIds, selectAll]);

  const isContactsLoading = isSearch ? globalSearchedContactsLoading : globalContactsLoading;
  const isContactsDataLength = isSearch ? globalSearchedContacts.length : globalContacts.length;
  return (
    <>
      <Wrapper
        addToListMode={addToListMode && !globalAddToListMode}
        isContactSelected={activeList}
        className={classNames('sub-container', {
          mainContainer: !isDashboard,
          tableViewContainer: listView,
          tableViewMainContainer: listView && page !== TAB_AUDIENCE.CONTACTS && !isDashboard,
          shortHeight: addToListMode && !globalAddToListMode,
        })}
      >
        {showConfirmation && (
          <DialogWrapper>
            <div className="back-overlay" />
            <ConfirmDialog
              cancel="Cancel"
              confirm={footerActionType === FooterActionsEnum.ADD_TO_LIST ? 'Confirm' : 'Delete'}
              onConfirm={getConfirmationHandle()}
              onCancel={handleCloseConfirmationDialog}
              title={getMessageString()}
              titleQuestion={null}
            />
          </DialogWrapper>
        )}
        {isContactsLoading && isContactsDataLength === 0 && !filtersApplied ? (
          <div className="heading-div">
            {[1, 2].map((item) => (
              <SkeletonCustom
                key={`heading-skeleton-${item}`}
                height="30px"
                width="120px"
                diameter="8px"
              />
            ))}
          </div>
        ) : (
          <div className="heading-div">
            <div className="heading-filter-div">
              {filtersApplied && isContactsLoading ? (
                <SkeletonCustom
                  height="30px"
                  width="120px"
                  diameter="8px"
                  margin="0 0 0 10px"
                />
              ) : <SecondaryHeading title={`Audience (${isSearch ? globalSearchedTotalContacts : globalTotalContacts})`} />}
              {isDashboard || (addToListMode && !globalAddToListMode) ? null
                : (
                  <ToggleFilterButtonGlobal
                    onApplyFilters={handleApplyFilters}
                    applied={filtersApplied}
                    onClearFilters={handleClearFilters}
                  />
                )}
            </div>
            {(addToListMode && !globalAddToListMode)
              ? null : (
                <ViewSwitcherComponent
                  viewSwitch={page === 'contacts'}
                  redirectLink="/audiences/contacts"
                  goBackLink={globalAddToListMode ? `/audiences/view/?list_id=${listId}` : '/audiences/'}
                  {...(page === 'contacts' && filtersApplied && { handleClick: handleGoBackClick })}
                />
              )}
          </div>
        )}
        {!listView ? (
          <ContactsGrid
            data={isSearch ? globalSearchedContacts : globalContacts}
            loading={isSearch ? globalSearchedContactsLoading : globalContactsLoading}
            listView={listView}
            loadMore={loadMore}
            handleSelectContacts={handleSelectContacts}
            selectedCount={handleGetSelectedIds().length}
            selectedContactsIds={handleGetSelectedIds()}
            selectDisable={isListSelected}
            isSearch={isSearch}
          />
        ) : (
          <ContactsTileTable
            isGlobal
            loadMore={loadMore}
            updateSortingConfig={updateSortingConfig}
            isSearched={isSearch}
            loading={isSearch ? globalSearchedContactsLoading : globalContactsLoading}
            totalContacts={isSearch ? globalSearchedTotalContacts : globalTotalContacts}
            selectAll={selectAll}
            contacts={globalContacts}
            updateSortingOrders={updateSortingOrders}
            sortOrder={sortOrder}
            searchedContacts={globalSearchedContacts}
            holdSelectedIds={holdSelectedIds}
            isDashboard={isDashboard}
            searchLoading={globalSearchedContactsLoading}
            totalSearchContacts={globalSearchedTotalContacts}
            updateContactSuccess={globalContactUpdateSuccess}
            addToListMode={addToListMode}
            isListActive={activeList === 'list'}
            excludedContactsIds={selectedContactsIds}
            disableSelectAll={handleDisableSelectAll()}
            handleSelectContacts={handleSelectContacts}
            handleSelectAll={handleSelectAll}
            handleHoldSelectedIds={handleHoldSelectedIds}
            handleConfirmation={handleShowConfirmationDialog}
            selectDisable={isListSelected}
            newContactAdded={newContactAdded}
          />
        )}
      </Wrapper>
      <Suspense fallback={<></>}>
        <ContactsFooterWrapper
          toggle={showFooter}
          list={false}
          count={getFooterCount()}
          showAddToList
          showRemoveFromList={isSearch}
          addToListMode={addToListMode}
          globalAddToListMode={globalAddToListMode}
          clearSelection={clearSelection}
          handleConfirmation={handleShowConfirmationDialog}
          selectAll={selectAll}
          selectedContacts={selectedContacts}
          selectedCount={selectAll ? holdSelectedIds.length - selectedContactsIds.length : holdSelectedIds.length}
          selectedOrganization={globalOrganizationSelected}
          selectedDesignation={globalDesignationSelected}
          selectedPersonality={globalPersonalitySelected}
          selectedStatus={globalStatusSelected}
          selectedContactsIds={selectedContactsIds}
        />
      </Suspense>
    </>
  );
};

AudienceContacts.defaultProps = {
  isDashboard: false,
  isGlobal: false,
  addToListMode: false,
};
export default AudienceContacts;
